"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const classnames = require("classnames");
const uikit_e_field_1 = require("../../common/components/uikit-e-field");
exports.AdvancedAccordion = ({ translate, accordionOpened, onAccordionOpenedChanged }, children) => (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
    hyperapp_1.h("div", { className: "e-accordion" },
        hyperapp_1.h("label", { className: classnames(['e-accordion__title'], { 'e-accordion__title-active': accordionOpened }), onclick: () => onAccordionOpenedChanged(!accordionOpened) }, translate('advancedSettingsLabel')),
        hyperapp_1.h("div", { className: "e-accordion__content" }, children))));
//# sourceMappingURL=advanced-accordion.js.map